jQuery(document).ready(function($){

  if($('.t-podcast-template')[0]){
    let pendingLoad = 0;

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ Build Query
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function build_query(args) {
    
      let paramsObj = args.reduce(function(result, current) {
        return Object.assign(result, current);
      }, {});

      paramsObj = $.param(paramsObj);

      return paramsObj;
    }
    
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ Page
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.page = function () {
    var page = parseInt($(this).hasClass('page-numbers.current')) || 1;

    if ($(this).hasClass('next page-numbers')) {
        page++;
    } else if ($(this).hasClass('prev page-numbers')) {
        page--;
    } else if ($(this).hasClass('page-numbers')) {
        page = parseInt($(this).text());
    }

    return page;
  };

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ FakeUrlParams
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    function fake_url_params($paged = '') {
      
      const query              = [];
      const $category_input    = $('#active_categories');
      const category_values    = $category_input.val().split(',');
      let is_archive           = $category_input.data('is-archive');
      
      const $tag_input         = $('#active_tags');
      const tag_values         = $tag_input.val().split(',');
      
      const $author_input      = $('#active_authors');
      const author_values      = $author_input.val().split(',');

      if(category_values.length >= 1 && !is_archive && category_values[0] !== '') query.push({"category_name" : category_values.join('+')});
      if(tag_values.length >= 1 && tag_values[0] !== '') query.push({'tag' : tag_values.join('+')});
      if(author_values.length >= 1 && author_values[0] !== '') query.push({'author' : author_values.join('+')})
      const params = build_query(query);

      if((category_values[0] === '' && is_archive) || (category_values.length > 1 && is_archive)){
        window.location.pathname = '/posts/';
        window.history.pushState(window.location.origin + window.location.pathname, '','?' + params);
      }else{
        window.history.pushState(window.location.origin + window.location.pathname, '', '?' + params);
      }

    }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ AddFiltersToHiddenInputs
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  function editFilterInputs(inputField, value) {
    const currentFilters = inputField.val().split(',');
    const newFilter      = value.toString();

    if (currentFilters.includes(newFilter)) {
      const i = currentFilters.indexOf(newFilter);
      currentFilters.splice(i, 1);
      inputField.val(currentFilters);
    } else {
      if(inputField.val() !== ''){
        inputField.val(inputField.val() + ',' + newFilter);
      }else{
        inputField.val(newFilter);
      }
    }
  }

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ 
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function get_podcast_posts(paged = 1){
      const activeTags     = $('#active_tags').val().split(',');
      const activeCategory = $('#active_categories').val().split(',');
      const activeAuthors  = $('#active_authors').val().split(',');
      
      const $postsWrapper = $('.o-all-posts__posts');
      const tagsPanelId   = $('.m-tab-list__item--tags button').attr('aria-controls');
      const $tagPanelList = $(`#${tagsPanelId}`).find('.m-filters-panel__list');

      const categoryPanelId    = $('.m-tab-list__item--categories button').attr('aria-controls');
      const $categoryPanelList = $(`#${categoryPanelId}`).find('.m-filters-panel__list');

      const authorsPanelId    = $('.m-tab-list__item--authors button').attr('aria-controls');
      const $authorsPanelList = $(`#${authorsPanelId}`).find('.m-filters-panel__list');
      const $selected         = $('.m-filters-panel__selected-filters');

      const $pagination = $('.o-all-posts__pages');

      $.ajax({
        type: 'POST',
        url: AJAX.url,
        data: {
          action        : 'get_podcast_posts',
          nonce         : AJAX.nonce,
          activeCategory: activeCategory,
          activeTags    : activeTags,
          activeAuthors : activeAuthors,
          paged         : paged,
        },
        dataType: 'json',
        beforeSend: function() {
          pendingLoad++;
          $('.o-all-posts__loading').addClass('o-all-posts__loading--active');
        },
        success: function(results){
          if(results.data.posts){

            $postsWrapper.empty();
            $postsWrapper.append(results.data.posts);

            $tagPanelList.empty();
            $tagPanelList.append(results.data.tags);

            $categoryPanelList.empty();
            $categoryPanelList.append(results.data.categories);

            $authorsPanelList.empty();
            $authorsPanelList.append(results.data.authors);

            $selected.empty();
            $selected.append(results.data.selected);

            $pagination.empty();
            $pagination.append(results.data.pagination);

            $('html, body').animate({
              scrollTop: $('.o-all-posts').offset().top - 500
            }, 350);
            
          }
        },
        complete: function(){
          pendingLoad--;
          $('.o-all-posts__loading').removeClass('o-all-posts__loading--active');
        }
      });
    }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Tag Filter
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-all-posts').on('click', '.m-filter[data-tag-filter]', function(e){

      e.preventDefault();

      const filter   = $(this);

      editFilterInputs($('#active_tags'), filter.data('tag-filter'));
      fake_url_params();

      get_podcast_posts();

    });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Authors Filter
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-all-posts').on('click', '.m-filter[data-author-filter]', function(e){
      e.preventDefault();

      const filter = $(this);

      editFilterInputs($('#active_authors'), filter.data('author-filter'));
      fake_url_params();

      get_podcast_posts();

    });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Category Filter
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    $('.o-all-posts').on('click', '.m-filter[data-cat-filter]', function(e) {

      e.preventDefault();

      const filter = $(this);

      editFilterInputs($('#active_categories'), filter.data('cat-filter'));
      fake_url_params();

      get_podcast_posts();

    });


//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// ✅ Clear All
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-all-posts').on('click', '.m-filters-panel__clear', function(e){
    e.preventDefault();

    const $category_input    = $('#active_categories');
    const $tag_input         = $('#active_tags');
    const $author_input      = $('#active_authors');

    $category_input.attr('value', '');
    $tag_input.attr('value', '');
    $author_input.attr('value', '');

    fake_url_params();
    get_podcast_posts();
  });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Pagination
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-all-posts__pages').on('click', '.page-numbers', function(e){
      e.preventDefault();
      const $pages = $('.o-all-posts__pages').find('.page-numbers');
      const $page = $(this).page();

      $pages.removeClass('current');
      $(this).addClass('current');
      
      get_podcast_posts($page);

    });
  }
});